import React from 'react'
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined'
import PushPanel from './PushPanel'

interface Props {
    title: string
    body: string
}

const NotificationPreview: React.FC<Props> = ({ title, body }) => {
    const [mode, setMode] = React.useState<'phone' | 'desktop'>('phone')
    const shownTitle = title?.trim() || 'Notification title'
    const shownBody = body?.trim() || 'Notification message appears here.'

    const bubble = (
        <Box sx={{
            display: 'flex', gap: 1.5, p: 1.5, borderRadius: mode === 'phone' ? '16px' : '6px',
            bgcolor: 'rgba(255,255,255,0.94)', boxShadow: mode === 'desktop' ? '0 8px 24px rgba(0,0,0,.5)' : 'none',
            width: '100%', maxWidth: mode === 'phone' ? '100%' : 360,
        }}>
            <Box component="img" src="/wolf-pack-logo.png" alt="" sx={{ width: 36, height: 36, borderRadius: '50%', flexShrink: 0, objectFit: 'cover', background: '#141414' }} />
            <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontSize: 10, color: '#6b7280' }}>WOLF PACK - now</Typography>
                <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#111', overflowWrap: 'anywhere' }}>{shownTitle}</Typography>
                <Typography sx={{ fontSize: 12, color: '#222', overflowWrap: 'anywhere' }}>{shownBody}</Typography>
            </Box>
        </Box>
    )

    return (
        <PushPanel
            title="Notification preview"
            icon={<PhoneIphoneOutlinedIcon sx={{ color: '#ff6a3d', fontSize: 20 }} />}
            action={
                <ToggleButtonGroup
                    size="small"
                    exclusive
                    value={mode}
                    onChange={(_, v) => v && setMode(v)}
                    sx={{
                        '& .MuiToggleButton-root': { color: '#898989', borderColor: '#333', textTransform: 'none', fontSize: 12, py: 0.3 },
                        '& .Mui-selected': { color: '#ff6a3d !important', background: '#ff6a3d15 !important' },
                    }}
                >
                    <ToggleButton value="phone">Phone</ToggleButton>
                    <ToggleButton value="desktop">Desktop</ToggleButton>
                </ToggleButtonGroup>
            }
        >
            {mode === 'phone' ? (
                <Box sx={{ mx: 'auto', maxWidth: 320, p: 2, pt: 4, borderRadius: '30px', border: '6px solid #111927', background: 'linear-gradient(160deg, #4D5761, #111927)' }}>
                    {bubble}
                </Box>
            ) : (
                <Box sx={{ p: 3, display: 'flex', justifyContent: 'flex-end', borderRadius: '8px', background: '#1a1a1a' }}>
                    {bubble}
                </Box>
            )}
            <Typography sx={{ fontSize: 11, color: '#5a5a5a', mt: 2 }}>
                Approximate rendering; actual appearance depends on the device and OS.
            </Typography>
        </PushPanel>
    )
}

export default NotificationPreview
